import { Component } from '@angular/core';

@Component({
    selector: 'verification-email',
    templateUrl: './verification-email.component.html',
    styleUrls: ['./verification-email.component.less']
})
export class VerificationEmailComponent {

    public email: string | undefined = '';
    fullLiveUrl = window.fullLiveUrl;
    isBusinessDoctors: boolean = false;

    constructor() {
        this.email = localStorage.getItem('newUserEmail') ?? '';
        this.isBusinessDoctors = (String)(window['isBusinessDoctors']).toLowerCase() === 'true';
    }

    goToMainSite(): void {
        window.location.href = "https://www.brixx.com";
    }

    goToSignUp(): void {
        const language = localStorage.getItem('language');
        localStorage.clear();
        if (language) {
            localStorage.setItem('language', language);
        }
        document.location.href = this.fullLiveUrl + 'sign-up';
    }
}